import {AsyncPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from '../../../core/service/auth.service';
import {UserService} from '../../../core/service/user.service';
import {ImpersonateModalComponent} from '../modal/modal-views/impersonate-modal/impersonate-modal';

@Component({
    selector: 'app-impersonate-bar',
    templateUrl: './impersonate-bar.component.html',
    styleUrls: ['./impersonate-bar.component.scss'],
    standalone: true,
    imports: [
      AsyncPipe,
      ImpersonateModalComponent
    ]
})
export class ImpersonateBarComponent implements OnInit{
  public displayName$!:  Observable<string | undefined>;
  public isImpersonating$!: Observable<boolean | undefined>;
  public modalOpen = false;

  constructor(private userService: UserService, private authService: AuthService) {}

  ngOnInit() {
    this.displayName$ = this.authService.getCurrentUserDisplayName();
    this.isImpersonating$ = this.authService.isImpersonating();
  }

  public openModal() {
    this.modalOpen = true;
  }

  public onModalClose() {
    this.modalOpen = false;
  }

  public stopImpersonating() {
    this.userService.stopImpersonating();
  }
}
